import { render } from "./menu-drawer.vue?vue&type=template&id=6bd65b78"
import script from "./menu-drawer.vue?vue&type=script&lang=js"
export * from "./menu-drawer.vue?vue&type=script&lang=js"

import "./menu-drawer.vue?vue&type=style&index=0&id=6bd65b78&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__